<template>
  <div>
    <sj-button style="margin:10px" @click="click1">普通Notify</sj-button>
    <sj-button style="margin:10px" @click="click2">成功Notify</sj-button>
    <sj-button style="margin:10px" @click="click3">失败Notify</sj-button>
    <sj-button style="margin:10px" @click="click4">长的Notify</sj-button>
  </div>
</template>

<script>
export default {
  methods: {
    click1() {
      this.$SjNotify({
        message: "普通Notify",
        duration: 0,
        showClose: true
      });
    },
    click2() {
      this.$SjNotify({
        message: "成功Notify",
        type: "success"
      });
    },
    click3() {
      this.$SjNotify({
        message: "失败Notify",
        type: "error"
      });
    },
    click4() {
      this.$SjNotify({
        message:
          "压力测试文件4_1577947559_4333fec6315f4420a9fce4b0d2d3c5c7.pdf",
        subMessage: "f987f10c-1fa5-4faf-b3ba-d352b22f115e",
        type: "success",
        duration: 0
      });
    }
  }
};
</script>

<style scoped lang="less"></style>
